<template>
    <div id="tabela-listagem-cnpj-header" class="mt-5 pt-3 mb-3">
        <b-row class="float-left">
            <form
                class="form-inline ml-3"
                @submit.prevent="handlePesquisar"
            >
                <b-form-group
                    id="tabela-listagem-cnpj-header-search"
                    label-for="search"
                >
                    <b-form-input
                        type="search"
                        v-model="searchValue"
                        :disabled="tabelaEstaDesabilitada"
                        placeholder="Digite o nome ou CNPJ para pesquisar"
                        aria-label="Pesquisar"
                        style="width:320px;"
                    ></b-form-input>
                </b-form-group>

                <b-button
                    type="submit"
                    variant="outline-secondary"
                    class="ml-2"
                    @click="limparFiltro"
                    :disabled="tabelaEstaDesabilitada"
                >
                    Limpar Filtro
                </b-button>
            </form>
        </b-row>
        <b-row
            class="float-right mt-4"
            :class="{
                'text-muted': tabelaEstaDesabilitada,
            }"
        >
            <span>Exibir</span>
            <select
                class="ml-2"
                v-model="itensPorPagina"
                :disabled="tabelaEstaDesabilitada"
            >
                <option
                    v-for="qntItens in listaDeItensPorPagina"
                    :value="qntItens"
                    v-bind:key="qntItens"
                >
                    {{ qntItens }}
                </option>
            </select>
            <span class="ml-2 mr-3">Linhas</span>
        </b-row>
    </div>
</template>

<script>
export default {
    name: "tabelaListagemCNPJHeader",
    props: {
        search: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        porPagina: {
            type: Number,
            default: 5,
        },
        listaPorPagina: {
            type: Array,
            default: () => [5, 10, 20, 50, 100, 200],
        },
    },
    data() {
        return {
            searchValue: "",
            itensPorPagina: this.porPagina,
            listaDeItensPorPagina: this.listaPorPagina,
            tabelaEstaDesabilitada: false,
        };
    },
    watch: {
        'search': {
            immediate: true,
            handler(newVal) {
                this.searchValue = newVal;
            },
        },
        'disabled': {
            immediate: true,
            handler(newVal) {
                this.tabelaEstaDesabilitada = newVal;
            },
        },
        itensPorPagina(newVal) {
            this.$emit('porPaginaAtualizado', newVal);
        },
        searchValue(newVal) {
            this.$emit('searchAtualizado', newVal);
        },
    },
    methods: {
        handlePesquisar() {
            this.$emit('searchAtualizado', this.searchValue);
        },
        limparFiltro() {
            this.searchValue = "";
            this.$emit('searchAtualizado', "");
        },
    },
};
</script>

<style scoped>
/** clearfix */
#tabela-listagem-cnpj-header:after {
    content: ' ';
    display: block;
    clear: both;
    visibility: hidden;
    height: 0;
}
#tabela-listagem-cnpj-header-search input {
    width: 315px;
    /** define a largura do campo de pesquisa para não estourar no mobile */
    max-width: calc(100vw - 110px);
}
</style>
